import { cancelReservation } from 'pages/UserProfile/components/TicketsAndReserv/reducer'
import { connect } from 'react-redux'
import { restoreBooking } from './reducer'

const mapStateToProps = (state) => {
    return {
        failReferenceNumber: state.pages.paymentVerify.failReferenceNumber,
    }
}

const hocPaymentFailed = (InnerComponent) =>
    connect(mapStateToProps, { cancelReservation, restoreBooking })(InnerComponent)

export default hocPaymentFailed
